<div class="cookie-banner" *ngIf="visible" role="dialog" aria-live="polite" aria-label="Aviso de cookies">
  <div class="cookie-copy">
    Usamos cookies para medir el uso del sitio y mejorar tu experiencia.
  </div>
  <div class="cookie-actions">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="reject()">Rechazar</button>
    <button type="button" class="btn btn-primary btn-sm" (click)="accept()">Aceptar</button>
  </div>
</div>
